import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { BlockWrapper } from '../../ui-kit/BlockWrapper.js';
import { RichText } from '../../ui-kit/RichText/RichText.js';
import { Text } from '../../ui-kit/Text/Text.js';
import { joinList } from '../../utils/joinList.js';
const investmentCellColorMap = {
    yellow: 'bg-yellow',
    green: 'bg-green',
    'green-light': 'bg-green-light',
    'green-dark': 'bg-green-dark',
};
const investmentCellSizeMap = {
    XS: 'h-10',
    S: 'h-16',
    M: 'h-24',
    L: 'h-32',
    XL: 'h-52',
};
export const InvestmentInfo = JSX((props) => {
    const { className = '', __html, isDotted, investmentZeroColumn, investmentColumns, ...rest } = props;
    const columns = investmentColumns ? [...investmentColumns] : [];
    if (investmentZeroColumn) {
        columns.unshift(investmentZeroColumn);
    }
    return (_jsx(BlockWrapper, { className: className, defaultPadding: "p-4xl", ...rest, children: _jsxs("div", { className: "container text-m font-light space-y-4xl", children: [columns?.length ? (_jsxs("div", { children: [_jsxs("div", { className: "flex items-end relative pl-3xl pr-lg text-white", children: [joinList(_jsx("div", { className: "w-px h-4 bg-gray" }))(columns.map(renderInvestmentColumn)), _jsx("div", { className: "absolute right-3xl w-px h-4 bg-gray" })] }), _jsx("div", { className: "border-t border-gray -mt-xs mx-3xl" }), _jsx("div", { className: "flex justify-between text-primary-text mt-s -mx-5xl", children: columns.map(renderInvestmentColumnTitle) })] })) : null, __html ? (_jsx("div", { className: "max-w-2xl font-light text-base", children: _jsx(RichText, { __html: __html, isDotted: isDotted, itemSize: "list-s" }) })) : null] }) }));
});
const renderInvestmentColumn = (column, i, arr) => {
    const isSecondColumn = i === 1;
    const isLastColumn = i === arr.length - 1;
    return (_jsx("div", { className: `${getColumnClasses(isSecondColumn, isLastColumn, column.cells)}`, children: column.cells?.length ? (_jsx("div", { className: `w-full ${isLastColumn ? 'border-4 border-green-more-dark p-1.5 min-w-72' : ''}`, children: column.cells.reverse().map(renderInvestmentCell) })) : null }, `column_${i}`));
};
const getColumnClasses = (isSecondColumn, isLastColumn, cells = []) => [
    cells.length ? 'flex-1' : 'flex-0',
    cells.length && !isSecondColumn && !isLastColumn ? 'pl-s' : '',
    cells.length && !isLastColumn ? 'pr-s pb-3xl' : 'pb-xl',
].join(' ');
const renderInvestmentCell = (cell, i) => {
    const cellSize = cell.cellSize || 'XS';
    const cellColor = cell.cellColor || 'green';
    return cell.text ? (_jsx("div", { className: `flex-1 flex items-center justify-center relative py-xs ${investmentCellSizeMap[cellSize]} ${investmentCellColorMap[cellColor]} ${cellSize === 'XS' ? 'px-s' : 'px-5xl'}`, children: _jsx(Text, { align: "text-center", children: cell.text }) }, `cell_${i}`)) : null;
};
const renderInvestmentColumnTitle = (column, i) => column?.title ? (_jsx("div", { className: "flex-1 max-w-44 text-center px-xs last:pr-4xl last:max-w-52", children: column.title }, `title_${i}`)) : null;
//# sourceMappingURL=InvestmentInfo.js.map